import { FloatingFormItem, Group, InputDecimal } from '@/components/_common';
import CouponPaymentMethodSelect from '@/components/_common/CouponPaymentMethodSelect';
import {
  TaxCouponFormValues,
  TaxCouponPaymentType,
} from '@/core/domain/coupon/coupons/coupons.types';
import { useDefaultEmptyFieldError } from '@/hooks';
import { Button, Card, Col, Empty, Form, Input, Row, Typography } from 'antd';
import { FaPlus, FaTrash } from 'react-icons/fa';
import CardAccreditorSelect from '@/components/_common/CardAccreditorSelect';

const { Title } = Typography;

const InvoiceCFeMethodPayments: React.FC = () => {
  const form = Form.useFormInstance<TaxCouponFormValues>();
  const formValues = Form.useWatch([], form);

  const ruleRequired = useDefaultEmptyFieldError();

  return (
    <>
      <Form.List name="payments" initialValue={[]}>
        {(fields, action) => (
          <>
            <Group position="between" style={{ marginBottom: 24 }}>
              <Title level={4} style={{ margin: 0 }}>
                Dados de pagamento
              </Title>

              <Button onClick={() => action.add()} type="primary" ghost>
                <Group>
                  <FaPlus /> pagamento
                </Group>
              </Button>
            </Group>

            {!fields.length && (
              <Card
                bordered
                style={{ borderRadius: 8 }}
                bodyStyle={{ padding: 12 }}
              >
                <Empty description="Adicione um método de pagamento (pode ser cadastrado posteriormente)" />
              </Card>
            )}

            {fields.map((field, index) => {
              const formField = formValues?.payments[index];
              const hasCard =
                formField?.paymentType === TaxCouponPaymentType.DEBIT_CARD ||
                formField?.paymentType === TaxCouponPaymentType.CREDIT_CARD;

              return (
                <Card
                  bordered
                  style={{ borderRadius: 8 }}
                  bodyStyle={{ padding: 12 }}
                >
                  <Group position="between" style={{ marginBottom: 24 }}>
                    <Title level={5} style={{ margin: 0 }}>
                      Pagamento
                    </Title>

                    <Button
                      danger
                      onClick={() => action.remove(index)}
                      size="small"
                      shape="round"
                    >
                      <Group>
                        <FaTrash size={12} />
                        Remover
                      </Group>
                    </Button>
                  </Group>

                  <Row gutter={[16, 16]} key={field.key}>
                    <Col span={24} md={12}>
                      <FloatingFormItem
                        parentFieldName="payments"
                        name={[index, 'paymentType']}
                        label="Tipo de pagamento"
                        rules={[ruleRequired]}
                      >
                        <CouponPaymentMethodSelect />
                      </FloatingFormItem>
                    </Col>

                    <Col span={24} md={12}>
                      <FloatingFormItem
                        parentFieldName="payments"
                        name={[index, 'value']}
                        label="Valor a pagar (R$)"
                        rules={[ruleRequired]}
                      >
                        <InputDecimal />
                      </FloatingFormItem>
                    </Col>

                    {hasCard && (
                      <>
                        <Col span={24} md={12}>
                          <FloatingFormItem
                            parentFieldName="payments"
                            name={[index, 'acquirer', 'type']}
                            label="Credenciadora do cartão"
                            rules={[ruleRequired]}
                          >
                            <CardAccreditorSelect />
                          </FloatingFormItem>
                        </Col>

                        <Col span={24} md={12}>
                          <FloatingFormItem
                            parentFieldName="payments"
                            name={[index, 'acquirer', 'authorizationCode']}
                            label="Cód. de autorização"
                            rules={[ruleRequired]}
                          >
                            <Input />
                          </FloatingFormItem>
                        </Col>
                      </>
                    )}
                  </Row>
                </Card>
              );
            })}
          </>
        )}
      </Form.List>
    </>
  );
};

export default InvoiceCFeMethodPayments;
